export const OPEN_COLLECTIVE_EMBED_MODAL_ID = 'open-collective-embed-modal';

interface OpenCollectiveEmbedModalProps {
  ticketSlug: string | null;
  onClose: () => void;
}

export const OpenCollectiveEmbedModal = ({
  ticketSlug,
  onClose,
}: OpenCollectiveEmbedModalProps) => {
  return (
    <>
      <input
        type="checkbox"
        id={OPEN_COLLECTIVE_EMBED_MODAL_ID}
        className="modal-toggle"
      />
      <label
        htmlFor={OPEN_COLLECTIVE_EMBED_MODAL_ID}
        className="modal cursor-pointer"
        onClick={onClose}
      >
        <div className="modal-box bg-white p-0 pr-1 md:pr-4 overflow-hidden relative w-11/12 md:w-10/12 max-w-4xl">
          <label
            htmlFor={OPEN_COLLECTIVE_EMBED_MODAL_ID}
            className="btn btn-sm btn-circle absolute right-2 top-2"
            onClick={onClose}
          >
            ✕
          </label>
          {ticketSlug && (
            <iframe
              src={`https://opencollective.com/embed/devfest-for-ukraine-93217149/contribute/${ticketSlug}`}
              style={{
                width: '100%',
                minHeight: '100vh',
                paddingBottom: '40px',
              }}
            />
          )}
        </div>
      </label>
    </>
  );
};
